// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Applications_pageContent__3k0bj"};